import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _p;
var _excluded = ["name", "illustration"];
import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import Box from '../Box/Box';
import Illustration from '../Illustration/Illustration';
import Button from '../Button/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
Login component
*/
function Login(_ref) {
  var name = _ref.name,
    illustration = _ref.illustration,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: "st_login",
    children: /*#__PURE__*/_jsxs(Box, {
      padding: {
        all: 'mlg'
      },
      className: "st_login__box",
      children: [illustration && /*#__PURE__*/_jsx(Illustration, {
        className: "st_login__illustration",
        name: illustration
      }), /*#__PURE__*/_jsx("h1", {
        className: "st_login__name",
        children: name
      }), _p || (_p = /*#__PURE__*/_jsx("p", {
        className: "st_login__text",
        children: "Please click login to continue"
      })), /*#__PURE__*/_jsx(Button, _extends({
        primary: true,
        fullWidth: true
      }, otherProps, {
        children: "Login"
      }))]
    })
  });
}
process.env.NODE_ENV !== "production" ? Login.propTypes = {
  /** dom element for the BUTTON */
  componentEl: componentElPropTypes,
  /** name of app */
  name: PropTypes.string.isRequired,
  /** name of illustraton to show */
  illustration: PropTypes.string,
  /** click handler for the BUTTON */
  onClick: PropTypes.func.isRequired
} : void 0;
Login.defaultProps = {
  componentEl: componentElDefaults,
  illustration: null
};
export default Login;